import { atom } from "recoil";

export const IsShowTandCState = atom<boolean>({
    key: "is-show-term-condition-toggle-state-key",
    default: true,
});